import React from "react";
import "./Home.css";

const Home = () => {
  return <div className="home" />;
};

export default Home;
